import * as tslib_1 from "tslib";
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { AfterViewInit, ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { GridComponent } from '@progress/kendo-angular-grid';
import { aggregateBy, orderBy } from '@progress/kendo-data-query';
import { DataDictionaryApi } from '../../../api/data-dictionary-api';
import { LayerApi } from '../../../api/layer-api';
import { util } from '../../../classes/util';
import { BooleanConverter, InputConverter, NumberConverter } from '../../../inputConverter';
import { keys } from '../../../keys';
import { ExportService } from '../../../services/export.service';
import { LayerService } from '../../../services/layer.service';
import { StorageService } from '../../../services/storage.service';
import { ToSqlStringService } from '../../../services/to-sql-string.service';
import { BaseComponent } from '../../base.component';
/* tslint:disable:template-cyclomatic-complexity */
var DataTableComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DataTableComponent, _super);
    /* tslint:disable:max-file-line-count */
    function DataTableComponent(_vcr, changeDetectorRef, exportService, layerService, dataDictionaryApi, toSqlStringService, layerApi, LoggingService, userSettingsService, authService) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.changeDetectorRef = changeDetectorRef;
        _this.exportService = exportService;
        _this.layerService = layerService;
        _this.dataDictionaryApi = dataDictionaryApi;
        _this.toSqlStringService = toSqlStringService;
        _this.layerApi = layerApi;
        _this.LoggingService = LoggingService;
        _this.userSettingsService = userSettingsService;
        _this.authService = authService;
        _this.geoSnapTableId = 161;
        _this.aggregates = [];
        _this._columnSortOrder = 'database';
        _this.columnSettingsFilterText = '';
        _this.columnSettingsSortField = 'order';
        _this.columnSettingsSortDescending = false;
        _this.gridColumns = [];
        _this.fullData = [];
        _this.showFooter = false;
        _this.footerText = {};
        _this.rowCount = '';
        _this.selectedObjectIds = [];
        _this.showSelected = false;
        _this.updateStorage = true;
        _this.layerChildTables = null;
        _this.childTableChildParentKeyColumnNames = null;
        _this.featureChildTables = null;
        _this.tableIdToTableDictionary = {};
        _this.showCloseOptions = false;
        _this.hideCustomSort = true;
        _this.enableMultiTabs = false;
        _this.multiTabsArr = [];
        _this.closeTab = new EventEmitter();
        _this.ondrawcomplete = new EventEmitter();
        _this.ondraw = new EventEmitter();
        _this.openEditor = new EventEmitter();
        _this.columnSettingsDialogOpened = false;
        _this._columnSettings = [];
        _this.dataFetched = [];
        _this.delayForFetchingNewColumnData = 800;
        _this.layerColumns = [];
        _this._opened = false;
        _this.pageSize = 20;
        _this.recordEditorEnabled = false;
        _this.selectableSettings = {
            checkboxOnly: true,
            mode: 'multiple'
        };
        _this.titleProperty = 'name';
        _this.toolbarPosition = 'top';
        _this.maxDefaultColumns = 10; // When insufficient columnSettings are supplied. We fill up the gridColumns to this number.
        _this.maxRecordsFetched = 10000000;
        _this.defaultRecordsFetched = 5000;
        _this.enableAdditionalInformation = false;
        _this.scrollSize = 20;
        _this.scrollSpeed = 1;
        _this.selectedRecordFetch = _this.defaultRecordsFetched = _this.maxRecordsFetched;
        _this.maxRecordFetchList = [
            { name: '100', value: 100 },
            { name: '500', value: 500 },
            { name: '1,000', value: 1000 },
            { name: '5,000', value: 5000 },
            { name: '10,000', value: 10000 },
            { name: '50,000', value: 50000 },
            { name: '100,000', value: 100000 }
        ];
        _this._mapcoreProps = [];
        _this.mapcorePropsIndex = 0;
        _this.availableCababilities = [];
        _this.userPermissions = [];
        _this.refreshGrid = function () {
            _this.refreshGridData();
        };
        _this.columnSettingsFilteredForDialog = [];
        _this.close = function (esriLayerId) {
            if (esriLayerId) {
                var closeIndex = _this._mapcoreProps.findIndex(function (p) { return p.esriLayerId === esriLayerId; });
                if (closeIndex > -1) {
                    _this.closeTab.emit(esriLayerId);
                    _this._mapcoreProps.splice(closeIndex, 1);
                    if (closeIndex === _this.mapcorePropsIndex && _this.mapcorePropsIndex >= _this._mapcoreProps.length) {
                        _this.mapcorePropsIndex = _this._mapcoreProps.length - 1;
                    }
                    if (_this._mapcoreProps.length < 2) {
                        _this.enableMultiTabs = false;
                        _this.multiTabsArr = [];
                        _this.curMultiTab = '';
                    }
                    if (!_this._mapcoreProps.length) {
                        _this.opened = false;
                        _this.dataFetched = [];
                        _this.selectedObjectIds = [];
                        _this.layerChildTables = [];
                        _this.hideCustomSort = true;
                        _this.lassoTool.destroy();
                    }
                }
            }
            else if (_this._mapcoreProps.length > 1) {
                if (_this._mapcoreProps.length === 2) {
                    _this.enableMultiTabs = false;
                    _this.multiTabsArr = [];
                    _this.curMultiTab = '';
                }
                _this.closeTab.emit(_this.mapcoreProps.esriLayerId);
                _this._mapcoreProps.splice(_this.mapcorePropsIndex, 1);
                _this.mapcorePropsIndex = 0;
            }
            else {
                _this.closeTab.emit(_this.mapcoreProps.esriLayerId);
                _this.mapcoreProps.dataTableArr = [];
                _this._mapcoreProps = [];
                _this.opened = false;
                _this.dataFetched = [];
                _this.selectedObjectIds = [];
                _this.layerChildTables = [];
                _this.hideCustomSort = true;
                _this.lassoTool.destroy();
            }
            _this.showCloseOptions = false;
        };
        _this.closeAll = function () {
            if (_this._mapcoreProps) {
                while (_this._mapcoreProps.length > 0) {
                    _this.close();
                }
            }
        };
        _this.allVisible = false;
        _this.allSum = false;
        _this.allAverage = false;
        _this.columnSortByDBOrder = function (a, b) {
            if (a.databaseColumnOrder > b.databaseColumnOrder) {
                return 1;
            }
            else if (a.databaseColumnOrder > b.databaseColumnOrder) {
                return -1;
            }
            return 0;
        };
        _this.hasChildTables = function () {
            if (_this.layerChildTables) {
                return true; // TODO: We need to know if this individual feature actually has data in any childTables
            }
            else {
                return false;
            }
        };
        _this.expandDetailsBy = function (dataItem) {
            return dataItem.objectid;
        };
        _this.sortColumns = function (columns) {
            var alphaSort = function (a, b) {
                var aComp = a.displayName.toUpperCase();
                var bComp = b.displayName.toUpperCase();
                if (aComp.localeCompare(bComp) > 1) {
                    return 1;
                }
                else if (aComp.localeCompare(bComp) < 1) {
                    return -1;
                }
                return 0;
            };
            var dbSort = function (a, b) {
                if (a.databaseColumnOrder > b.databaseColumnOrder) {
                    return 1;
                }
                else if (a.databaseColumnOrder < b.databaseColumnOrder) {
                    return -1;
                }
                return 0;
            };
            var findColumnIndex = function (cs) {
                return _this.columnSettings.findIndex(function (c) { return c.name.toUpperCase() === cs.name.toUpperCase(); });
            };
            var customSort = function (a, b) {
                var aIndex = findColumnIndex(a);
                var bIndex = findColumnIndex(b);
                if (aIndex > bIndex) {
                    return 1;
                }
                else if (aIndex < bIndex) {
                    return -1;
                }
                return 0;
            };
            if (columns) {
                switch (_this.columnSortOrder) {
                    case 'alphabetical':
                        columns.sort(alphaSort);
                        break;
                    case 'custom':
                        columns.sort(customSort);
                        break;
                    case 'database':
                        columns.sort(dbSort);
                        break;
                    default:
                        break;
                }
            }
        };
        _this.accessingLocalStorage = Promise.resolve();
        _this.registerEvent('closeTab', _this.closeTab);
        _this.localStorageService = new StorageService({ userSettingsService: userSettingsService, authService: authService });
        _this.authService.permissions.subscribe(function (permissions) { return _this.userPermissions = permissions || []; });
        return _this;
    }
    Object.defineProperty(DataTableComponent.prototype, "columnSortOrder", {
        get: function () { return this._columnSortOrder; },
        set: function (val) {
            var _this = this;
            if (val !== this._columnSortOrder) {
                this._columnSortOrder = val;
                (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var hasKey;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.accessingLocalStorage];
                            case 1:
                                _a.sent();
                                if (!this.updateStorage) return [3 /*break*/, 6];
                                return [4 /*yield*/, this.localStorageService.hasKey(this.columnSettingsStorageKey)];
                            case 2:
                                hasKey = _a.sent();
                                if (!hasKey) return [3 /*break*/, 4];
                                return [4 /*yield*/, this.localStorageService.setPropertyOfObject(this.columnSettingsStorageKey, [], 'sortBy', this._columnSortOrder, 'data-table')];
                            case 3:
                                _a.sent();
                                return [3 /*break*/, 6];
                            case 4: return [4 /*yield*/, this.createOrUpdateFromLocalStorage('order')];
                            case 5:
                                _a.sent();
                                _a.label = 6;
                            case 6:
                                this.setColumnSettingsFilteredForDialog();
                                return [2 /*return*/];
                        }
                    });
                }); })();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "visibleGridColumns", {
        get: function () {
            return this.gridColumns ? this.gridColumns.filter(function (c) { return c.visible; }) : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "rowCountNumber", {
        get: function () {
            return !!this.rowCount ? parseInt(this.rowCount.replace(/,/g, ''), 10) : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "columnSettings", {
        get: function () { return this._columnSettings; },
        set: function (val) {
            var _this = this;
            if (val !== this._columnSettings) {
                this._columnSettings = val;
                (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var hasKey;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.accessingLocalStorage];
                            case 1:
                                _a.sent();
                                if (!this.updateStorage) return [3 /*break*/, 6];
                                return [4 /*yield*/, this.localStorageService.hasKey(this.columnSettingsStorageKey)];
                            case 2:
                                hasKey = _a.sent();
                                if (!hasKey) return [3 /*break*/, 4];
                                return [4 /*yield*/, this.localStorageService.setPropertyOfObject(this.columnSettingsStorageKey, [], 'settings', this.mapColumnsForSave(this._columnSettings), 'data-table')];
                            case 3:
                                _a.sent();
                                return [3 /*break*/, 6];
                            case 4: return [4 /*yield*/, this.createOrUpdateFromLocalStorage('settings')];
                            case 5:
                                _a.sent();
                                _a.label = 6;
                            case 6:
                                this.setColumnCheckboxes();
                                this.setColumnSettingsFilteredForDialog();
                                return [2 /*return*/];
                        }
                    });
                }); })();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "opened", {
        get: function () { return this._opened; },
        set: function (val) {
            this._opened = val;
            if (this._opened) {
                if (this.mapcoreProps && this.mapcoreProps.dataTableArr && this.mapcoreProps.dataTableArr[this.mapcorePropsIndex]) {
                    if (!this.mapcoreProps.dataTableArr[this.mapcorePropsIndex].maxFetchRecord) {
                        this.mapcoreProps.dataTableArr[this.mapcorePropsIndex].maxFetchRecord = this.defaultRecordsFetched;
                    }
                    else {
                        this.selectedRecordFetch = this.mapcoreProps.dataTableArr[this.mapcorePropsIndex].maxFetchRecord;
                    }
                }
                window.addEventListener('itemInserted', this.storageUpdated.bind(this));
            }
            else {
                window.removeEventListener('itemInserted', this.storageUpdated.bind(this));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "LayerService", {
        get: function () {
            return this.layerService;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "mapcoreProps", {
        get: function () {
            return this._mapcoreProps[this.mapcorePropsIndex];
        },
        set: function (mapcoreProps) {
            var _this = this;
            var newEsriLayerId = mapcoreProps.esriLayerId;
            this.gridDataResult = null;
            this.gridColumns = [];
            this.showSelected = false;
            this._columnSortOrder = 'database';
            this.changeDetectorRef.detectChanges();
            //find if the layer has already been added
            var i = this._mapcoreProps.findIndex(function (x) { return newEsriLayerId === x.esriLayerId; });
            if (i > -1) {
                //already exist
                this.mapcorePropsIndex = i;
            }
            else {
                //create new entry
                this._mapcoreProps.push(mapcoreProps);
                this.mapcorePropsIndex = this._mapcoreProps.length - 1;
            }
            if (this._mapcoreProps[this.mapcorePropsIndex].dataTableArr && this._mapcoreProps.length > 1) {
                this.enableMultiTabs = true;
                this.multiTabsArr = this._mapcoreProps[this.mapcorePropsIndex].dataTableArr;
                this.curMultiTab = newEsriLayerId;
            }
            else {
                this.enableMultiTabs = false;
                this.multiTabsArr = [];
                this.curMultiTab = '';
            }
            if (this.mapcoreProps.state === undefined) {
                this.mapcoreProps.state = {};
                this.mapcoreProps.state.skip = 0;
            }
            if (!mapcoreProps.isExternal && mapcoreProps.permissions && this.userPermissions && this.userPermissions.length) {
                this.availableCababilities = mapcoreProps.permissions.filter(function (per) { return _this.userPermissions.includes(per.name); }).map(function (per) { return per.action; });
            }
            this.refreshGridData().then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.createOrUpdateFromLocalStorage()];
                        case 1:
                            _a.sent();
                            this.changeDetectorRef.detectChanges();
                            return [2 /*return*/];
                    }
                });
            }); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "canDelete", {
        get: function () { return this.availableCababilities.includes('DR'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "canInsert", {
        get: function () { return this.availableCababilities.includes('IR'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "canUpdate", {
        get: function () { return this.availableCababilities.includes('UR'); },
        enumerable: true,
        configurable: true
    });
    DataTableComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 1:
                        _a.mapView = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.storageUpdated = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!((!e.detail.caller || e.detail.caller !== 'data-table') && e.detail.key.startsWith(keys.storage.columnSettingsStorage.slice(0, keys.storage.columnSettingsStorage.indexOf('{') - 1)))) return [3 /*break*/, 5];
                        if (!!this.updateStorage) return [3 /*break*/, 2];
                        return [4 /*yield*/, util.retryUntilValue(function () { return _this.updateStorage ? true : undefined; }, 2000, 100)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!this.updateStorage) return [3 /*break*/, 5];
                        this.updateStorage = false;
                        return [4 /*yield*/, this.createOrUpdateFromLocalStorage()];
                    case 3:
                        _a.sent();
                        this.refreshColumnSettings();
                        return [4 /*yield*/, this.refreshGridData()];
                    case 4:
                        _a.sent();
                        this.changeColumnSortOrder();
                        this.updateStorage = true;
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.setHashedUrl = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var hashBuffer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.mapcoreProps && this.mapcoreProps.url)) return [3 /*break*/, 2];
                        return [4 /*yield*/, crypto.subtle.digest('SHA-1', new TextEncoder().encode(this.mapcoreProps.url))];
                    case 1:
                        hashBuffer = _a.sent();
                        this.mapcoreProps.hashedUrl = Array.from(new Uint8Array(hashBuffer)).map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.refreshGridData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        this.rowCount = '';
                        if (!(this.mapcoreProps !== undefined)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.updateLayerInformationIfNeeded()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchDataForAllVisibleColumns()];
                    case 2:
                        _a.sent();
                        this.loadDataIntoGrid();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.selectForCheckBox = function (checkBoxIdentifier, event) {
        switch (checkBoxIdentifier) {
            case 'visibility':
                this.columnSettings.forEach(function (col) { return col.visible = event.target.checked; });
                break;
            case 'sum':
                this.columnSettings.filter(function (col) { return col.isNumeric && col.calculateSum !== null; }).forEach(function (col) { return col.calculateSum = event.target.checked; });
                break;
            case 'average':
                this.columnSettings.filter(function (col) { return col.isNumeric && col.calculateAverage !== null; }).forEach(function (col) { return col.calculateAverage = event.target.checked; });
                break;
            default:
                break;
        }
        this.columnSettingChange();
    };
    DataTableComponent.prototype.setColumnSettingsFilteredForDialog = function () {
        if (this.columnSettingsFilterText.length) {
            var searchText_1 = this.columnSettingsFilterText.toLowerCase();
            this.columnSettingsFilteredForDialog = this.columnSettings.filter(function (x) { return x.name.toLowerCase().indexOf(searchText_1) >= 0 || x.displayName.toLowerCase().indexOf(searchText_1) >= 0; });
        }
        else {
            this.columnSettingsFilteredForDialog = tslib_1.__spread(this.columnSettings);
        }
        this.sortColumns(this.columnSettingsFilteredForDialog);
        this.changeDetectorRef.detectChanges();
    };
    Object.defineProperty(DataTableComponent.prototype, "systemLayerId", {
        get: function () {
            var systemLayerId = 0;
            if (this.mapcoreProps) {
                systemLayerId = this.mapcoreProps.id || this.mapcoreProps.idFromSavedLayer || this.mapcoreProps.parentId;
            }
            return systemLayerId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "tableId", {
        get: function () {
            if (this.mapcoreProps && this.mapcoreProps.tables && this.mapcoreProps.tables[0].id) {
                return this.mapcoreProps.tables[0].id;
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "columnSettingsStorageKey", {
        get: function () {
            var storageKey;
            if (this.mapcoreProps) {
                var projectIdClause = this.toSqlStringService.getPetlProjectIdClauseIfPresent(this.mapcoreProps.parentId, this.mapcoreProps.query, this.mapcoreProps.isPETL);
                if (projectIdClause) {
                    // use a different storage key for PETL layers
                    storageKey = keys.storage.columnSettingsStorage.replace('{layer_id}', 'petl-' + projectIdClause.value);
                }
                else if (!this.mapcoreProps.isExternal) {
                    storageKey = keys.storage.columnSettingsStorage.replace('{layer_id}', 'table-' + this.tableId.toString());
                }
                else {
                    storageKey = keys.storage.columnSettingsStorage.replace('{layer_id}', 'ex-' + this.mapcoreProps.hashedUrl);
                }
            }
            return storageKey;
        } //**TODO Handle non-mapcore layers**
        ,
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "width", {
        get: function () {
            return window.innerWidth;
        },
        enumerable: true,
        configurable: true
    });
    DataTableComponent.prototype.addCommas = function (value) {
        return (typeof value === 'string' ? parseFloat(value) : value).toLocaleString();
    };
    DataTableComponent.prototype.calculateWidth = function (columnSetting) {
        var displayName = columnSetting.displayName;
        var wideCount = 0;
        var normalCount = 0;
        for (var i = 0; i < displayName.length; i++) {
            var ch = displayName.charAt(i);
            if ((ch >= 'A' && ch <= 'Z' && ch !== 'I') ||
                ch === 'm' ||
                ch === 'w') {
                wideCount++;
            }
            else {
                normalCount++;
            }
        }
        var startingWidth = 50;
        var pixelsPerWideChar = 12;
        var pixelsPerNormalChar = 7;
        return (startingWidth +
            wideCount * pixelsPerWideChar +
            normalCount * pixelsPerNormalChar);
    };
    DataTableComponent.prototype.setColumnCheckboxes = function () {
        this.allVisible = this.columnSettings.every(function (col) { return col.visible; });
        this.allSum = this.columnSettings.filter(function (col) { return col.isNumeric && col.calculateSum !== null; }).every(function (col) { return col.calculateSum; });
        this.allAverage = this.columnSettings.filter(function (col) { return col.isNumeric && col.calculateAverage !== null; }).every(function (col) { return col.calculateAverage; });
    };
    DataTableComponent.prototype.columnSettingChange = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.setColumnCheckboxes();
                if (this.columnSettingsTimer) {
                    window.clearTimeout(this.columnSettingsTimer);
                }
                this.columnSettingsTimer = window.setTimeout(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.columnSettingsTimer = null;
                                return [4 /*yield*/, this.populateGridColumnsFromColumnSettings()];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, this.fetchDataIfNeeded()];
                            case 2:
                                _a.sent();
                                this.loadDataIntoGrid();
                                this.changeDetectorRef.detectChanges();
                                return [2 /*return*/];
                        }
                    });
                }); }, this.delayForFetchingNewColumnData);
                return [2 /*return*/];
            });
        });
    };
    DataTableComponent.prototype.download = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, rootQuery_1, filterQuery, stringifiedSort, i, exportParams, query, fieldNames, _loop_1, this_1, fieldNames_1, fieldNames_1_1, fieldName, tempData;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.mapcoreProps.isExternal) return [3 /*break*/, 2];
                        rootQuery_1 = { operator: 'AND', subqueries: [] };
                        if (this.mapcoreProps.parentQuery) {
                            if (!this.mapcoreProps.parentQuery.subqueries) {
                                if (this.mapcoreProps.parentQuery) {
                                    rootQuery_1.subqueries.push(this.mapcoreProps.parentQuery);
                                }
                            }
                            else {
                                this.mapcoreProps.parentQuery.subqueries.forEach(function (subQ) {
                                    rootQuery_1.subqueries.push(subQ);
                                });
                            }
                        }
                        if (this.mapcoreProps.query) {
                            if (!this.mapcoreProps.query.subqueries) {
                                if (this.mapcoreProps.query) {
                                    rootQuery_1.subqueries.push(this.mapcoreProps.query);
                                }
                            }
                            else {
                                this.mapcoreProps.query.subqueries.forEach(function (subQ) {
                                    rootQuery_1.subqueries.push(subQ);
                                });
                            }
                        }
                        if (this.mapcoreProps.state.filter) {
                            if (this.mapcoreProps.state.filter.filters.length > 0) {
                                filterQuery = { operator: this.mapcoreProps.state.filter.logic.toUpperCase(), subqueries: this.mapcoreProps.state.filter.filters };
                                filterQuery.subqueries.forEach(function (filter) {
                                    if (filter.operator === 'contains') {
                                        filter.operator = 'like';
                                    }
                                });
                                rootQuery_1.subqueries.push(filterQuery);
                            }
                        }
                        stringifiedSort = '';
                        if (this.mapcoreProps.state.sort) {
                            for (i = 0; i < this.mapcoreProps.state.sort.length; i++) {
                                if (this.mapcoreProps.state.sort[i].dir === undefined || this.mapcoreProps.state.sort[i].field === undefined) {
                                    this.mapcoreProps.state.sort.splice(i, 1);
                                    i--;
                                }
                            }
                            if (this.mapcoreProps.state.sort.length > 0) {
                                stringifiedSort = JSON.stringify(this.mapcoreProps.state.sort);
                            }
                            else {
                                stringifiedSort = '';
                            }
                        }
                        exportParams = {
                            layerId: this.systemLayerId,
                            query: rootQuery_1,
                            title: this.mapcoreProps.name,
                            sort: stringifiedSort
                        };
                        if (this.selectedObjectIds.length > 0) {
                            query = {
                                field: this.objectIdColumnName,
                                operator: 'IN',
                                value: this.selectedObjectIds.join(',')
                            };
                            rootQuery_1.subqueries.push(query);
                        }
                        fieldNames = this.gridColumns.map(function (x) { return x.name; });
                        if (this.layerColumns) {
                            // if layerColumns are present, pass those as as parameters, but perserve the order of the columns in fieldNames
                            exportParams.layerColumns = [];
                            _loop_1 = function (fieldName) {
                                var layerColumnsFound = this_1.layerColumns.filter(function (x) { return x.name.toLowerCase().trim() === fieldName.toLowerCase().trim(); });
                                if (layerColumnsFound.length) {
                                    exportParams.layerColumns.push(layerColumnsFound[0]);
                                }
                            };
                            this_1 = this;
                            try {
                                for (fieldNames_1 = tslib_1.__values(fieldNames), fieldNames_1_1 = fieldNames_1.next(); !fieldNames_1_1.done; fieldNames_1_1 = fieldNames_1.next()) {
                                    fieldName = fieldNames_1_1.value;
                                    _loop_1(fieldName);
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (fieldNames_1_1 && !fieldNames_1_1.done && (_a = fieldNames_1.return)) _a.call(fieldNames_1);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                        else {
                            exportParams.fieldNames = fieldNames;
                        }
                        return [4 /*yield*/, this.exportService.exportToExcelAndOpenUrl(exportParams)];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        tempData = tslib_1.__assign({}, this.grid.data);
                        //assign all data to grid when export to excel
                        this.grid.data = {
                            data: this.fullData,
                            total: this.fullData.length
                        };
                        this.grid.saveAsExcel();
                        this.grid.data = tslib_1.__assign({}, tempData);
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.populateLayerInformation = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_2, _b, _c, e_3, _d, layers, _loop_2, _e, _f, col, _g, _h, layerColumn, objectIdColumn;
            return tslib_1.__generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!this.systemLayerId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.layerApi.getLayerInfo(this.systemLayerId)];
                    case 1:
                        layers = _j.sent();
                        if (layers.length > 0) {
                            if (this.mapcoreProps === undefined) {
                                return [2 /*return*/, []];
                            }
                            this.layerRef = layers[0];
                            this.layerColumns.length = 0;
                            if (!this.mapcoreProps.columns) {
                                (_a = this.layerColumns).push.apply(_a, tslib_1.__spread(layers[0].columns));
                            }
                            else {
                                _loop_2 = function (col) {
                                    //find the related column in layers[0]
                                    var layersCol = layers[0].columns.find(function (x) { return x.databaseColumnOrder === col.databaseColumnOrder; });
                                    if (!layersCol) {
                                        return "continue";
                                    }
                                    //if found, append its listed dataType to mapcoreprops columns list
                                    if (layersCol.databaseDataType) {
                                        col.databaseDataType = layersCol.databaseDataType;
                                    }
                                };
                                try {
                                    //Use this.mapcoreProps.columns with layers[0]'s databaseDataType mapped to each respective column
                                    for (_e = tslib_1.__values(this.mapcoreProps.columns), _f = _e.next(); !_f.done; _f = _e.next()) {
                                        col = _f.value;
                                        _loop_2(col);
                                    }
                                }
                                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                finally {
                                    try {
                                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                                    }
                                    finally { if (e_2) throw e_2.error; }
                                }
                                (_c = this.layerColumns).push.apply(_c, tslib_1.__spread(this.mapcoreProps.columns));
                            }
                            this.layerColumns.sort(this.columnSortByDBOrder);
                            this.objectIdColumnName = this.layerService.getObjectIdColumnName(this.layerRef);
                            try {
                                for (_g = tslib_1.__values(this.layerColumns), _h = _g.next(); !_h.done; _h = _g.next()) {
                                    layerColumn = _h.value;
                                    layerColumn.name = layerColumn.name.toLowerCase();
                                    if (layerColumn.alias &&
                                        layerColumn.alias.toUpperCase() ===
                                            layerColumn.name.toUpperCase()) {
                                        layerColumn.alias = layerColumn.name.toUpperCase();
                                    }
                                }
                            }
                            catch (e_3_1) { e_3 = { error: e_3_1 }; }
                            finally {
                                try {
                                    if (_h && !_h.done && (_d = _g.return)) _d.call(_g);
                                }
                                finally { if (e_3) throw e_3.error; }
                            }
                            return [2 /*return*/, this.layerColumns];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        if (this.mapcoreProps.isExternal) {
                            this.layerColumns = tslib_1.__spread(this.mapcoreProps.columns);
                            this.layerColumns.sort(this.columnSortByDBOrder);
                            objectIdColumn = this.layerColumns.find(function (col) { return col.name.toLowerCase().replace('_', '').trim() === 'objectid'; });
                            this.objectIdColumnName = objectIdColumn ? objectIdColumn.name : null;
                            return [2 /*return*/, this.layerColumns];
                        }
                        _j.label = 3;
                    case 3: return [2 /*return*/, []];
                }
            });
        });
    };
    DataTableComponent.prototype.fetchDataForAllVisibleColumns = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fieldNames;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.dataFetched = [];
                        this.selectedObjectIds = [];
                        if (!(!this.gridColumns || !this.gridColumns.length)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.populateGridColumnsFromColumnSettings()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        fieldNames = this.gridColumns.map(function (x) { return x.name.toLowerCase().trim(); });
                        if (fieldNames.indexOf(this.objectIdColumnName.toLowerCase().trim()) < 0) {
                            fieldNames.push(this.objectIdColumnName.toLowerCase().trim());
                        }
                        if (this.childTableChildParentKeyColumnNames !== null) {
                            fieldNames = tslib_1.__spread(new Set(fieldNames.concat(this.childTableChildParentKeyColumnNames)));
                        }
                        if (!!this.mapcoreProps.isExternal) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.fetchDataForSpecifiedColumns(fieldNames)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.fetchExternalDataForSpecifiedColumns(fieldNames)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.fetchExternalDataForSpecifiedColumns = function (fieldNames) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchExternalData(fieldNames)];
                    case 1:
                        result = _a.sent();
                        this.dataFetched = result.map(function (row) {
                            var item = {};
                            Object.entries(row).forEach(function (_a) {
                                var _b = tslib_1.__read(_a, 2), col = _b[0], value = _b[1];
                                var colName = col;
                                var builtValue = value;
                                var matchingColumn = _this.layerColumns.find(function (c) { return c.name.toLowerCase().trim() === col.toLowerCase().trim(); });
                                if (matchingColumn && matchingColumn.domainValues) {
                                    colName = matchingColumn.name;
                                    var foundDomainValue = void 0;
                                    if (typeof value === 'number') {
                                        foundDomainValue = matchingColumn.domainValues.find(function (dv) { return parseFloat(dv.codeValue.toString()) === value; });
                                    }
                                    else {
                                        foundDomainValue = matchingColumn.domainValues.find(function (dv) { return dv.codeValue === value; });
                                    }
                                    if (foundDomainValue) {
                                        builtValue = { value: value, domainValue: foundDomainValue.codeValue + " - " + foundDomainValue.shortDescription };
                                    }
                                }
                                item[colName] = builtValue;
                            });
                            return item;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.fetchDataForSpecifiedColumns = function (fieldNames) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_4, _a, rootQuery, minRecords, multFactor, adjustment, roundFactor, calculatedAmount, result, dictionary, _loop_3, this_2, dictionary_1, dictionary_1_1, column, columns;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        rootQuery = { operator: 'AND', subqueries: [] };
                        if (this.mapcoreProps.parentQuery) {
                            rootQuery.subqueries.push(this.mapcoreProps.parentQuery);
                        }
                        if (this.mapcoreProps.query) {
                            rootQuery.subqueries.push(this.mapcoreProps.query);
                        }
                        this.defaultRecordsFetched = this.maxRecordsFetched;
                        if (fieldNames.length > 2) {
                            minRecords = 100000;
                            multFactor = 5;
                            adjustment = 4;
                            roundFactor = 1000;
                            calculatedAmount = Math.round((this.defaultRecordsFetched / ((multFactor * Math.sqrt(fieldNames.length)) - adjustment)) / roundFactor) * roundFactor;
                            this.defaultRecordsFetched = Math.max(calculatedAmount, minRecords);
                        }
                        if (this.mapcoreProps.dataTableArr && this.mapcoreProps.dataTableArr[this.mapcorePropsIndex]) {
                            if (!this.mapcoreProps.dataTableArr[this.mapcorePropsIndex].maxFetchRecord) {
                                this.selectedRecordFetch = this.mapcoreProps.dataTableArr[this.mapcorePropsIndex].maxFetchRecord = this.defaultRecordsFetched;
                            }
                            else {
                                this.selectedRecordFetch = this.mapcoreProps.dataTableArr[this.mapcorePropsIndex].maxFetchRecord;
                            }
                        }
                        else {
                            this.selectedRecordFetch = this.defaultRecordsFetched;
                        }
                        return [4 /*yield*/, this.layerApi.getData(this.systemLayerId, fieldNames, rootQuery, this.defaultRecordsFetched //this.selectedRecordFetch - for dropdown selection
                            )];
                    case 1:
                        result = _b.sent();
                        if (!(this.mapcoreProps && this.mapcoreProps.columns && !this.mapcoreProps.columns.some(function (c) { return !!c.domainValues; }) && this.mapcoreProps.metaTableId)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.dataDictionaryApi.getColumnsWithDomainValuesByMetaTableId(this.mapcoreProps.metaTableId)];
                    case 2:
                        dictionary = _b.sent();
                        if (dictionary) {
                            _loop_3 = function (column) {
                                var matchingColumn = this_2.mapcoreProps.columns.find(function (c) { return c.name.toLowerCase().trim() === column.columnName.toLowerCase().trim(); });
                                if (matchingColumn) {
                                    matchingColumn.domainValues = column.domainValues;
                                }
                            };
                            this_2 = this;
                            try {
                                for (dictionary_1 = tslib_1.__values(dictionary), dictionary_1_1 = dictionary_1.next(); !dictionary_1_1.done; dictionary_1_1 = dictionary_1.next()) {
                                    column = dictionary_1_1.value;
                                    _loop_3(column);
                                }
                            }
                            catch (e_4_1) { e_4 = { error: e_4_1 }; }
                            finally {
                                try {
                                    if (dictionary_1_1 && !dictionary_1_1.done && (_a = dictionary_1.return)) _a.call(dictionary_1);
                                }
                                finally { if (e_4) throw e_4.error; }
                            }
                        }
                        _b.label = 3;
                    case 3:
                        columns = [];
                        if (this.mapcoreProps && this.mapcoreProps.columns) {
                            columns = fieldNames.map(function (field) { return _this.mapcoreProps.columns.find(function (c) { return c.name.toLowerCase().trim() === field.toLowerCase().trim(); }) || { name: field.toLowerCase().trim() }; });
                        }
                        else {
                            columns = fieldNames.map(function (field) { return ({ name: field.toLowerCase().trim() }); });
                        }
                        this.dataFetched = result.map(function (row) {
                            var item = {};
                            row.forEach(function (value, i) {
                                var builtValue = value;
                                var col = columns[i];
                                if (col.domainValues) {
                                    var foundDomainValue = void 0;
                                    if (typeof value === 'number') {
                                        foundDomainValue = col.domainValues.find(function (dv) { return parseFloat(dv.codeValue.toString()) === value; });
                                    }
                                    else {
                                        foundDomainValue = col.domainValues.find(function (dv) { return dv.codeValue === value; });
                                    }
                                    if (foundDomainValue) {
                                        builtValue = { value: value, domainValue: foundDomainValue.codeValue + " - " + foundDomainValue.shortDescription };
                                    }
                                }
                                item[col.name] = builtValue;
                            });
                            return item;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.fetchDataIfNeeded = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fieldNames, dataKeys_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.dataFetched.length > 0)) return [3 /*break*/, 2];
                        fieldNames = this.gridColumns.map(function (x) { return x.name.toLowerCase().trim(); });
                        dataKeys_1 = Object.keys(this.dataFetched[0]).map(function (x) { return x.toLowerCase().trim(); });
                        if (!fieldNames.some(function (fieldName) { return !dataKeys_1.includes(fieldName); })) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchDataForAllVisibleColumns()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.fetchExternalData = function (outFields) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var formatResponse, featureLayer, results, query, keepRequesting, response;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formatResponse = function (response) {
                            return response.features.map(function (feature) {
                                return Object.keys(feature.attributes).reduce(function (acc, key) {
                                    acc[key.toLowerCase()] = feature.attributes[key];
                                    return acc;
                                }, {});
                            });
                        };
                        featureLayer = this.layerService.mapLayers.feature.find(function (element) { return element.mapcoreProps.guid === _this.mapcoreProps.guid; });
                        results = [];
                        if (!featureLayer) return [3 /*break*/, 3];
                        query = featureLayer.createQuery();
                        query.outFields = outFields;
                        query.num = this.maxRecordsFetched;
                        keepRequesting = true;
                        _a.label = 1;
                    case 1:
                        if (!keepRequesting) return [3 /*break*/, 3];
                        query.start = results.length;
                        return [4 /*yield*/, featureLayer.queryFeatures(query)];
                    case 2:
                        response = _a.sent();
                        if (!results.length) {
                            query.num = response.features.length;
                        }
                        results.push.apply(results, tslib_1.__spread(formatResponse(response)));
                        keepRequesting = response.exceededTransferLimit;
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/, results];
                }
            });
        });
    };
    DataTableComponent.prototype.fetchLayerChildTables = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, filteredChildTables;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.layerChildTables) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.layerService.getLayerChildTables(this.systemLayerId)];
                    case 1:
                        _a.layerChildTables = _b.sent();
                        filteredChildTables = this.layerChildTables.filter(function (childTable) { return childTable.tableId !== _this.geoSnapTableId; });
                        this.childTableChildParentKeyColumnNames = tslib_1.__spread(new Set(filteredChildTables.map(function (table) { return table.childParentKeyColumnName.toLowerCase().trim(); })));
                        this.childTableChildParentKeyColumnNames.push('objectid'); // add this in for 161 geosnap
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.updateLayerInformationIfNeeded = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.mapcoreProps.isExternal) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setHashedUrl()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        this.updateStorage = false;
                        _a = this;
                        return [4 /*yield*/, this.populateLayerInformation()];
                    case 3:
                        _a.columnSettings = (_b.sent()).map(function (lc) { return _this.getRefreshedColumnSetting(lc); });
                        this.updateStorage = true;
                        this.refreshColumnSettings();
                        return [4 /*yield*/, this.createOrUpdateFromLocalStorage()];
                    case 4:
                        _b.sent();
                        return [4 /*yield*/, this.populateGridColumnsFromColumnSettings()];
                    case 5:
                        _b.sent();
                        this.sortColumns(this.gridColumns);
                        if (!(this.systemLayerId && (!this.layerRef || this.layerRef.id !== this.systemLayerId))) return [3 /*break*/, 7];
                        if (!this.enableAdditionalInformation) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.fetchLayerChildTables()];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.cdkDrop = function (event) {
        var _this = this;
        if (this.columnSortOrder !== 'custom') {
            this.sortColumns(this._columnSettings);
        }
        moveItemInArray(this.columnSettings, event.previousIndex, event.currentIndex);
        this.columnSortOrder = 'custom';
        this.hideCustomSort = false;
        (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accessingLocalStorage];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.localStorageService.setPropertyOfObject(this.columnSettingsStorageKey, [], 'enableCustom', !this.hideCustomSort, 'data-table')];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.columnSettingChange()];
                    case 3:
                        _a.sent();
                        this.setColumnSettingsFilteredForDialog();
                        return [2 /*return*/];
                }
            });
        }); })();
    };
    DataTableComponent.prototype.dataStateChange = function (state) {
        this.mapcoreProps.state = state;
        this.loadDataIntoGrid();
    };
    DataTableComponent.prototype.columnResized = function (event) {
        var _this = this;
        var e_5, _a;
        var changes = false;
        var _loop_4 = function (colResize) {
            var match = this_3.columnSettings.find(function (col) { return col.name.toLowerCase() === colResize.column.field.toLowerCase(); });
            if (match) {
                match.width = colResize.newWidth;
                changes = true;
            }
        };
        var this_3 = this;
        try {
            for (var event_1 = tslib_1.__values(event), event_1_1 = event_1.next(); !event_1_1.done; event_1_1 = event_1.next()) {
                var colResize = event_1_1.value;
                _loop_4(colResize);
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (event_1_1 && !event_1_1.done && (_a = event_1.return)) _a.call(event_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
        if (changes) {
            (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.accessingLocalStorage];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.localStorageService.setPropertyOfObject(this.columnSettingsStorageKey, [], 'settings', this.mapColumnsForSave(this.columnSettings), 'data-table')];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); })();
        }
    };
    DataTableComponent.prototype.moveItemToTop = function (columnSetting) {
        var _this = this;
        var _a;
        if (this.columnSortOrder !== 'custom') {
            this.sortColumns(this._columnSettings);
        }
        (_a = this.columnSettings).splice.apply(_a, tslib_1.__spread([0, 0], this.columnSettings.splice(this.columnSettings.indexOf(columnSetting), 1)));
        this.columnSortOrder = 'custom';
        this.hideCustomSort = false;
        (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accessingLocalStorage];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.localStorageService.setPropertyOfObject(this.columnSettingsStorageKey, [], 'enableCustom', !this.hideCustomSort, 'data-table')];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.columnSettingChange()];
                    case 3:
                        _a.sent();
                        this.setColumnSettingsFilteredForDialog();
                        return [2 /*return*/];
                }
            });
        }); })();
    };
    DataTableComponent.prototype.getRefreshedColumnSetting = function (layerColumn, columnSetting) {
        if (columnSetting === void 0) { columnSetting = null; }
        if (!columnSetting) {
            columnSetting = tslib_1.__assign({}, layerColumn);
        }
        columnSetting.visible =
            columnSetting.visible || columnSetting.visible === undefined;
        columnSetting.isNumeric =
            ['FLOAT', 'NUMBER'].indexOf(layerColumn.databaseDataType) >= 0;
        columnSetting.displayName = layerColumn.name.toUpperCase();
        if (layerColumn.alias) {
            columnSetting.name = columnSetting.name.toUpperCase();
            columnSetting.displayName = layerColumn.alias;
        }
        if (!columnSetting.width) {
            columnSetting.width = this.calculateWidth(columnSetting);
        }
        if (layerColumn.databaseColumnOrder) {
            columnSetting.databaseColumnOrder = layerColumn.databaseColumnOrder;
        }
        return columnSetting;
    };
    DataTableComponent.prototype.loadDataIntoGrid = function () {
        var _this = this;
        var e_6, _a, _b;
        if (this.mapcoreProps) {
            var dataForGrid = this.dataFetched;
            if (this.mapcoreProps.state.filter) {
                var filters = this.mapcoreProps.state.filter.filters;
                var _loop_5 = function (filter) {
                    var field = filter.field;
                    var filterValue = filter.value.toLowerCase();
                    dataForGrid = dataForGrid.filter(function (x) {
                        var col = x[field];
                        var retVal = -1;
                        if (col) {
                            if (typeof col === 'object' && col.domainValue) {
                                retVal = col.domainValue.toString().toLowerCase().indexOf(filterValue);
                                if (retVal === -1) {
                                    retVal = col.value.toString().toLowerCase().indexOf(filterValue);
                                }
                            }
                            else {
                                retVal = col.toString().toLowerCase().indexOf(filterValue);
                            }
                        }
                        return retVal >= 0;
                    });
                };
                try {
                    for (var filters_1 = tslib_1.__values(filters), filters_1_1 = filters_1.next(); !filters_1_1.done; filters_1_1 = filters_1.next()) {
                        var filter = filters_1_1.value;
                        _loop_5(filter);
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (filters_1_1 && !filters_1_1.done && (_a = filters_1.return)) _a.call(filters_1);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
            }
            if (this.showSelected) {
                dataForGrid = dataForGrid.filter(function (x) { return _this.selectedObjectIds.indexOf(x[_this.objectIdColumnName]) >= 0; });
            }
            if (this.mapcoreProps.state.sort) {
                // Telerik's orderBy doesn't work on object values, so hold those to do the sort and they reapply them
                dataForGrid.forEach(function (val, i) { return val.oldIndex = i; });
                var holdData_1;
                _b = tslib_1.__read(dataForGrid.reduce(function (accu, row) {
                    var e_7, _a;
                    // Create map of object values to hold
                    var holdMap = new Map();
                    var newRow = {};
                    try {
                        for (var _b = tslib_1.__values(Object.keys(row)), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var field = _c.value;
                            var col = row[field];
                            // If the value is a Data Item object, store it with the field as a reference
                            if (_this.isDataItem(col)) {
                                // For future reference, if the field should be sorted on the domain value instead of the DB value, this is where that should be checked
                                holdMap.set(field, col);
                                newRow[field] = col.value;
                            }
                            else {
                                newRow[field] = col;
                            }
                        }
                    }
                    catch (e_7_1) { e_7 = { error: e_7_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_7) throw e_7.error; }
                    }
                    // Store the values map to a map based on the original index before sorting
                    accu[1].set(row.oldIndex, holdMap);
                    // Update the original data to remove the Data Item object
                    accu[0].push(newRow);
                    return accu;
                }, [[], new Map()]), 2), dataForGrid = _b[0], holdData_1 = _b[1];
                // Put the held data back after sorting
                dataForGrid = orderBy(dataForGrid, this.mapcoreProps.state.sort).map(function (row) {
                    var e_8, _a;
                    if (holdData_1.has(row.oldIndex)) {
                        var heldRowData = holdData_1.get(row.oldIndex);
                        try {
                            for (var _b = tslib_1.__values(Object.keys(row)), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var field = _c.value;
                                if (heldRowData.has(field)) {
                                    row[field] = heldRowData.get(field);
                                }
                            }
                        }
                        catch (e_8_1) { e_8 = { error: e_8_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_8) throw e_8.error; }
                        }
                    }
                    return row;
                });
            }
            this.detectUrls(dataForGrid);
            this.fullData = dataForGrid;
            this.populateAggregates();
            var skipAsNumber = Number(this.mapcoreProps.state.skip);
            this.gridDataResult = {
                data: dataForGrid.slice(skipAsNumber, skipAsNumber + this.pageSize),
                total: dataForGrid.length
            };
            this.rowCount = this.addCommas(dataForGrid.length);
            this.loading = false;
            this.changeDetectorRef.detectChanges();
        }
    };
    /**
     * Modifies the data passed in to add isUrl boolean if a url is detected for a column
     * @param dataForGrid Array of data rows
     */
    DataTableComponent.prototype.detectUrls = function (dataForGrid) {
        var e_9, _a, e_10, _b;
        if (dataForGrid && dataForGrid.length) {
            // Find the url column first
            var urlColumns = [];
            var nonurlColumns = [];
            var columnLength = Object.keys(dataForGrid[0]).length;
            try {
                for (var dataForGrid_1 = tslib_1.__values(dataForGrid), dataForGrid_1_1 = dataForGrid_1.next(); !dataForGrid_1_1.done; dataForGrid_1_1 = dataForGrid_1.next()) {
                    var row = dataForGrid_1_1.value;
                    var _loop_6 = function (col) {
                        // Iterate over every column in the row
                        if (!nonurlColumns.includes(col) &&
                            !urlColumns.includes(col)) {
                            // Only check columns that we don't know about yet
                            var value = row[col];
                            if (value !== null) {
                                // Only check if not null, as the url column could be nullable
                                var columnSetting = this_4.columnSettings.find(function (cs) { return cs.name === col; });
                                if (columnSetting && (columnSetting.isUrl || this_4.isUrl(value))) {
                                    urlColumns.push(col);
                                }
                                else {
                                    nonurlColumns.push(col);
                                }
                            }
                        }
                    };
                    var this_4 = this;
                    // Iterate over every row of data
                    for (var col in row) {
                        _loop_6(col);
                    }
                    if (columnLength === urlColumns.length + nonurlColumns.length) {
                        break;
                    } // If all columns have been checked, stop checking completly
                }
            }
            catch (e_9_1) { e_9 = { error: e_9_1 }; }
            finally {
                try {
                    if (dataForGrid_1_1 && !dataForGrid_1_1.done && (_a = dataForGrid_1.return)) _a.call(dataForGrid_1);
                }
                finally { if (e_9) throw e_9.error; }
            }
            if (urlColumns.length) {
                try {
                    for (var _c = tslib_1.__values(this.columnSettings), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var columnSetting = _d.value;
                        if (urlColumns.includes(columnSetting.name)) {
                            columnSetting.isUrl = true;
                        }
                        else {
                            columnSetting.isUrl = false;
                        }
                    }
                }
                catch (e_10_1) { e_10 = { error: e_10_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_10) throw e_10.error; }
                }
            }
        }
    };
    DataTableComponent.prototype.isUrl = function (value) {
        return (value &&
            typeof value === 'string' &&
            /^http[s]?:\/\/(?:[a-zA-Z]|[0-9]|[$-_@.&+]|[!*(), ]|(?:%[0-9a-fA-F][0-9a-fA-F]))+$/.test(value.trim()));
    };
    DataTableComponent.prototype.mapSelectedFeatures = function () {
        var _this = this;
        if (this.selectedObjectIds.length > 0) {
            var query = {
                field: this.objectIdColumnName,
                operator: 'IN',
                value: this.selectedObjectIds.join(',')
            };
            if (!this.mapcoreProps.isExternal) {
                var layerSettings = {
                    id: this.systemLayerId,
                    query: query,
                    zoomToLayer: true
                };
                this.layerService.addMapcoreLayersToMap([layerSettings]);
            }
            else {
                var featureLayer = this.layerService.mapLayers.feature.find(function (element) { return element.mapcoreProps.guid === _this.mapcoreProps.guid; });
                this.layerService.addExternalLayersToMap({
                    url: this.mapcoreProps.url,
                    name: featureLayer.title,
                    visible: true,
                    zoomToLayer: true
                }, tslib_1.__assign({}, this.mapcoreProps, { query: query }));
            }
            if (this.lassoTool) {
                this.lassoTool.clearFeatureResults();
            }
        }
    };
    DataTableComponent.prototype.multiPropertySort = function (sortSettings) {
        return function (a, b) {
            var e_11, _a;
            try {
                for (var sortSettings_1 = tslib_1.__values(sortSettings), sortSettings_1_1 = sortSettings_1.next(); !sortSettings_1_1.done; sortSettings_1_1 = sortSettings_1.next()) {
                    var sortSetting = sortSettings_1_1.value;
                    var name_1 = sortSetting.propertyName;
                    var descending = sortSetting.descending;
                    if (a[name_1] < b[name_1]) {
                        return descending ? 1 : -1;
                    }
                    if (a[name_1] > b[name_1]) {
                        return descending ? -1 : 1;
                    }
                }
            }
            catch (e_11_1) { e_11 = { error: e_11_1 }; }
            finally {
                try {
                    if (sortSettings_1_1 && !sortSettings_1_1.done && (_a = sortSettings_1.return)) _a.call(sortSettings_1);
                }
                finally { if (e_11) throw e_11.error; }
            }
            return 0;
        };
    };
    DataTableComponent.prototype.populateGridColumnsFromColumnSettings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_12, _a, visibleColumnSettings, settingsStorage, visibleColumnSettings_1, visibleColumnSettings_1_1, columnSetting, gridColumn, geometryColumn, geometryColumnSetting;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        visibleColumnSettings = this.columnSettings.filter(function (x) { return x.visible; });
                        if (!(this.mapcoreProps !== undefined)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.accessingLocalStorage];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.localStorageService.get(this.columnSettingsStorageKey)];
                    case 2:
                        settingsStorage = _b.sent();
                        if (!this.updateStorage) return [3 /*break*/, 7];
                        if (!(!settingsStorage || settingsStorage.settings.length === 0)) return [3 /*break*/, 4];
                        //first time
                        this.hideCustomSort = true;
                        return [4 /*yield*/, this.localStorageService.setPropertyOfObject(this.columnSettingsStorageKey, [], 'settings', this.mapColumnsForSave(this.columnSettings), 'data-table')];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 4:
                        if (!(JSON.stringify(settingsStorage.settings) !== JSON.stringify(this._columnSettings))) return [3 /*break*/, 6];
                        //consecutive times
                        if (settingsStorage.sortBy) {
                            this.columnSortOrder = settingsStorage.sortBy;
                            if (settingsStorage.sortBy === 'custom') {
                                this.hideCustomSort = false;
                            }
                        }
                        return [4 /*yield*/, this.localStorageService.setPropertyOfObject(this.columnSettingsStorageKey, [], 'settings', this.mapColumnsForSave(this.columnSettings), 'data-table')];
                    case 5:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        if (settingsStorage.sortBy) {
                            this.columnSortOrder = settingsStorage.sortBy;
                        }
                        _b.label = 7;
                    case 7:
                        this.sortColumns(visibleColumnSettings);
                        this.gridColumns = [];
                        try {
                            for (visibleColumnSettings_1 = tslib_1.__values(visibleColumnSettings), visibleColumnSettings_1_1 = visibleColumnSettings_1.next(); !visibleColumnSettings_1_1.done; visibleColumnSettings_1_1 = visibleColumnSettings_1.next()) {
                                columnSetting = visibleColumnSettings_1_1.value;
                                gridColumn = tslib_1.__assign({}, columnSetting);
                                gridColumn.name = gridColumn.name.toLowerCase().trim();
                                this.footerText[gridColumn.name] = '';
                                this.gridColumns.push(gridColumn);
                            }
                        }
                        catch (e_12_1) { e_12 = { error: e_12_1 }; }
                        finally {
                            try {
                                if (visibleColumnSettings_1_1 && !visibleColumnSettings_1_1.done && (_a = visibleColumnSettings_1.return)) _a.call(visibleColumnSettings_1);
                            }
                            finally { if (e_12) throw e_12.error; }
                        }
                        geometryColumn = this.columnSettings.find(function (c) { return c.name.toLowerCase().trim() === 'has_geometry'; });
                        if (geometryColumn && !this.gridColumns.find(function (c) { return c.name === geometryColumn.name; })) {
                            geometryColumnSetting = tslib_1.__assign({}, geometryColumn);
                            geometryColumnSetting.visible = false;
                            this.gridColumns.push(geometryColumnSetting);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.populateValidColumnSettings = function () {
        var _loop_7 = function (i) {
            var columnSetting = this_5.columnSettings[i];
            var foundLayerColumns = this_5.layerColumns.filter(function (x) { return x.name.toLowerCase() === columnSetting.name.toLowerCase(); });
            if (foundLayerColumns.length > 0) {
                var layerColumn = foundLayerColumns[0];
                columnSetting = this_5.getRefreshedColumnSetting(layerColumn, columnSetting);
            }
            else {
                this_5.columnSettings.splice(i, 1);
                i--;
            }
            out_i_1 = i;
        };
        var this_5 = this, out_i_1;
        for (var i = 0; i < this.columnSettings.length; i++) {
            _loop_7(i);
            i = out_i_1;
        }
    };
    DataTableComponent.prototype.populateColumnSettingsToMax = function () {
        var e_13, _a;
        var visibleColumnSettings = this.columnSettings.filter(function (x) { return x.visible; })
            .length;
        var _loop_8 = function (layerColumn) {
            if (this_6.columnSettings.filter(function (x) {
                return x.name.toLowerCase() === layerColumn.name.toLowerCase();
            }).length === 0) {
                var columnSetting = this_6.getRefreshedColumnSetting(layerColumn);
                if (visibleColumnSettings <= this_6.maxDefaultColumns) {
                    visibleColumnSettings++;
                }
                else {
                    columnSetting.visible = false;
                }
                this_6.columnSettings.push(columnSetting);
            }
        };
        var this_6 = this;
        try {
            for (var _b = tslib_1.__values(this.layerColumns), _c = _b.next(); !_c.done; _c = _b.next()) {
                var layerColumn = _c.value;
                _loop_8(layerColumn);
            }
        }
        catch (e_13_1) { e_13 = { error: e_13_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_13) throw e_13.error; }
        }
    };
    DataTableComponent.prototype.populateAggregates = function () {
        this.setAggregateArray();
        this.populateAggregateValues();
    };
    DataTableComponent.prototype.populateAggregateValues = function () {
        var e_14, _a;
        var fractionDigits = 4;
        if (this.aggregates && this.aggregates.length) {
            var data = this.fullData;
            var aggregateValues = aggregateBy(data, this.aggregates);
            var _loop_9 = function (field) {
                var gridColumn = this_7.gridColumns.find(function (c) { return c.name.toLowerCase().trim() === field.toLowerCase().trim(); });
                if (gridColumn) {
                    gridColumn.footerText = '';
                    var columnAggregates = aggregateValues[field];
                    if (columnAggregates.average !== undefined && columnAggregates.average !== null) {
                        gridColumn.average = columnAggregates.average;
                        var averageText = gridColumn.average.toFixed(fractionDigits);
                        gridColumn.footerText += 'Avg: ' + this_7.addCommas(averageText);
                    }
                    if (columnAggregates.sum !== undefined && columnAggregates.sum !== null) {
                        gridColumn.sum = columnAggregates.sum;
                        if (Math.floor(gridColumn.sum) === gridColumn.sum) {
                            gridColumn.footerText += ' Sum: ' + this_7.addCommas(gridColumn.sum);
                        }
                        else {
                            gridColumn.footerText += ' Sum: ' + this_7.addCommas(gridColumn.sum.toFixed(fractionDigits));
                        }
                    }
                    gridColumn.footerText = gridColumn.footerText.trim();
                    this_7.footerText[field.toLowerCase().trim()] = gridColumn.footerText;
                }
            };
            var this_7 = this;
            try {
                for (var _b = tslib_1.__values(Object.keys(aggregateValues)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var field = _c.value;
                    _loop_9(field);
                }
            }
            catch (e_14_1) { e_14 = { error: e_14_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_14) throw e_14.error; }
            }
        }
    };
    DataTableComponent.prototype.refreshColumnSettings = function () {
        this.populateValidColumnSettings();
        this.populateColumnSettingsToMax();
    };
    DataTableComponent.prototype.setAggregateArray = function () {
        var e_15, _a;
        var aggregates = [];
        try {
            for (var _b = tslib_1.__values(this.columnSettings), _c = _b.next(); !_c.done; _c = _b.next()) {
                var columnSetting = _c.value;
                if (columnSetting.calculateSum) {
                    aggregates.push({
                        field: columnSetting.name.toLowerCase(),
                        aggregate: 'sum'
                    });
                }
                if (columnSetting.calculateAverage) {
                    aggregates.push({
                        field: columnSetting.name.toLowerCase(),
                        aggregate: 'average'
                    });
                }
            }
        }
        catch (e_15_1) { e_15 = { error: e_15_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_15) throw e_15.error; }
        }
        this.showFooter = aggregates.length > 0;
        this.aggregates = aggregates;
    };
    DataTableComponent.prototype.changeColumnSortOrder = function () {
        this.sortColumns(this.gridColumns);
        this.loadDataIntoGrid();
    };
    DataTableComponent.prototype.changeRecordFetch = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        this.mapcoreProps.dataTableArr[this.mapcorePropsIndex].maxFetchRecord = this.selectedRecordFetch;
                        return [4 /*yield*/, this.localStorageService.setPropertyOfObject(this.columnSettingsStorageKey, [], 'selectedRecordFetch', this.selectedRecordFetch, 'data-table')];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.columnSettingChange()];
                    case 2:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.changeCurMultiTab = function () {
        var _this = this;
        //find the the mapcorePropsIndex that has the selected layerId
        var i = this._mapcoreProps.findIndex(function (x) { return _this.curMultiTab === x.esriLayerId; });
        if (i > -1) {
            this.mapcoreProps = this._mapcoreProps[i];
            this.selectedRecordFetch = this.mapcoreProps.dataTableArr[i].maxFetchRecord;
        }
        if (this.lassoTool) {
            this.lassoTool.deactivate();
            this.lassoTool.clearFeatureResults();
        }
    };
    DataTableComponent.prototype.sortColumnSettings = function () {
        var sortSettings = [];
        sortSettings.push({
            propertyName: this.columnSettingsSortField,
            descending: this.columnSettingsSortDescending
        });
        if (this.columnSettingsSortField === 'visible') {
            sortSettings[0].descending = !sortSettings[0].descending;
        }
        return this.multiPropertySort(sortSettings);
    };
    DataTableComponent.prototype.toggleColumnSettings = function () {
        this.columnSettingsDialogOpened = !this.columnSettingsDialogOpened;
    };
    DataTableComponent.prototype.toggleColumnVisibility = function (columnSetting) {
        columnSetting.visible = !columnSetting.visible;
        this.columnSettingChange();
    };
    DataTableComponent.prototype.toggleShowSelected = function () {
        this.showSelected = !this.showSelected;
        this.loadDataIntoGrid();
    };
    DataTableComponent.prototype.toggleSortColumnSettings = function (sortField) {
        if (this.columnSettingsSortField === sortField) {
            this.columnSettingsSortDescending = !this.columnSettingsSortDescending;
        }
        else {
            this.columnSettingsSortDescending = false;
        }
        this.columnSettingsSortField = sortField;
    };
    DataTableComponent.prototype.createOrUpdateFromLocalStorage = function (skip) {
        if (skip === void 0) { skip = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.accessingLocalStorage = (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var hasKey, settingsStorage, columnStorageSettings;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.localStorageService.hasKey(this.columnSettingsStorageKey)];
                                    case 1:
                                        hasKey = _a.sent();
                                        if (!hasKey) return [3 /*break*/, 3];
                                        return [4 /*yield*/, this.localStorageService.get(this.columnSettingsStorageKey)];
                                    case 2:
                                        settingsStorage = _a.sent();
                                        if (skip === 'settings') {
                                            this._columnSettings = this.mapColumnsFromSaved(this.columnSettings, settingsStorage ? settingsStorage.settings : []);
                                        }
                                        else {
                                            this.columnSettings = this.mapColumnsFromSaved(this.columnSettings, settingsStorage ? settingsStorage.settings : []);
                                        }
                                        if (skip === 'order') {
                                            this._columnSortOrder = settingsStorage && settingsStorage.sortBy ? settingsStorage.sortBy : 'database';
                                        }
                                        else {
                                            this.columnSortOrder = settingsStorage && settingsStorage.sortBy ? settingsStorage.sortBy : 'database';
                                        }
                                        if (settingsStorage.selectedRecordFetch) {
                                            this.selectedRecordFetch = settingsStorage.selectedRecordFetch;
                                        }
                                        if (settingsStorage && settingsStorage.enableCustom) {
                                            this.hideCustomSort = false;
                                        }
                                        return [3 /*break*/, 5];
                                    case 3:
                                        columnStorageSettings = { showAll: false, sortBy: this.columnSortOrder, settings: this.mapColumnsForSave(this.columnSettings), enableCustom: !this.hideCustomSort };
                                        if (!(this.systemLayerId > 0)) return [3 /*break*/, 5];
                                        return [4 /*yield*/, this.localStorageService.set(this.columnSettingsStorageKey, columnStorageSettings, 'data-table')];
                                    case 4:
                                        _a.sent();
                                        _a.label = 5;
                                    case 5: return [2 /*return*/];
                                }
                            });
                        }); })();
                        return [4 /*yield*/, this.accessingLocalStorage];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DataTableComponent.prototype.toggleCloseOptions = function () {
        this.showCloseOptions = !this.showCloseOptions;
    };
    DataTableComponent.prototype.selectAllToggle = function () {
        if (this.lassoTool) {
            this.lassoTool.clearFeatureResults();
        }
        if (this.selectedObjectIds.length) {
            this.selectedObjectIds = [];
        }
        else {
            if (this.dataFetched.length) {
                var objectIdKey_1 = Object.keys(this.dataFetched[0]).find(function (k) { return k.toLowerCase() === 'objectid'; });
                if (objectIdKey_1) {
                    this.selectedObjectIds = this.dataFetched.map(function (d) { return typeof d[objectIdKey_1] === 'object' ? d[objectIdKey_1].value : d[objectIdKey_1]; }).filter(function (oid) { return !!oid; });
                }
            }
        }
        this.changeDetectorRef.detectChanges();
    };
    DataTableComponent.prototype.rowClass = function (context) {
        var retVal = { noGeometry: false };
        if (Object.keys(context.dataItem).includes('has_geometry') && context.dataItem.has_geometry === 'N') {
            retVal.noGeometry = true;
        }
        return retVal;
    };
    DataTableComponent.prototype.selectFromMap = function () {
        var _this = this;
        this.lassoTool.deactivate();
        this.lassoTool.containerElement = this.hostElement;
        var subs = [];
        subs.push(this.lassoTool.oncomplete.subscribe(function () {
            var featureresults = _this.lassoTool.layerFeatureResults.map(function (r) { return r.featureResults; }).flat();
            if (featureresults.length) {
                var frObjectIdKey_1 = Object.keys(featureresults[0].attributes).find(function (key) { return key.toLowerCase() === 'objectid'; });
                if (frObjectIdKey_1) {
                    var selectedIds = featureresults.map(function (result) { return result.attributes[frObjectIdKey_1]; });
                    _this.selectedObjectIds = tslib_1.__spread(new Set(selectedIds));
                }
            }
            if (_this.dataFetched.length) {
                var objectIdKey_2 = Object.keys(_this.dataFetched[0]).find(function (k) { return k.toLowerCase() === 'objectid'; });
                if (objectIdKey_2) {
                    _this.selectedObjectIds = _this.selectedObjectIds.filter(function (id) { return !!_this.dataFetched.find(function (d) { return d[objectIdKey_2] === id; }); });
                }
            }
            _this.lassoTool.deactivate();
            subs.forEach(function (sub) { return sub.unsubscribe(); });
            _this.loading = false;
            _this.changeDetectorRef.detectChanges();
        }));
        subs.push(this.lassoTool.drawEnd.subscribe(function () {
            _this.selectedObjectIds = [];
            _this.loading = true;
            _this.ondrawcomplete.emit();
            _this.changeDetectorRef.detectChanges();
        }));
        this.lassoTool.spatialQueryType = 'feature';
        this.lassoTool.runSpatialQueryOnSketchComplete = true;
        this.lassoTool.reactivateSketchOnSketchComplete = false;
        this.lassoTool.displayFeatureGraphicsAfterSpatialQuery = true;
        this.lassoTool.sketchDefaultCreateOptions = { mode: 'freehand' };
        this.lassoTool.mapView = this.mapView;
        this.lassoTool.esriLayers = [this.layerService.getExistingEsriLayerById(this.mapcoreProps.esriLayerId)];
        this.lassoTool.clearFeatureResults();
        this.lassoTool.activate();
        this.ondraw.emit();
    };
    DataTableComponent.prototype.selectionChange = function (_event) {
        if (this.lassoTool) {
            this.lassoTool.clearFeatureResults();
        }
    };
    DataTableComponent.prototype.triggerOpenEditor = function (asEdit) {
        if (asEdit === void 0) { asEdit = false; }
        var objectId = asEdit ? this.selectedObjectIds[0] : null;
        this.openEditor.emit({ layerId: this.mapcoreProps.esriLayerId, objectId: objectId });
    };
    DataTableComponent.prototype.mapColumnsForSave = function (columnSettings) {
        return columnSettings.map(function (column) { return ({
            name: column.name,
            visible: column.visible,
            width: column.width,
            displayName: column.displayName,
            databaseDataType: column.databaseDataType,
            databaseColumnOrder: column.databaseColumnOrder,
            columnIdentifierId: column.columnIdentifierId,
            isNumeric: column.isNumeric,
            calculateAverage: column.calculateAverage,
            calculateSum: column.calculateSum
        }); });
    };
    DataTableComponent.prototype.mapColumnsFromSaved = function (columnSettings, fromSaved) {
        columnSettings.forEach(function (column) {
            var match = fromSaved.find(function (x) { return x.name === column.name; });
            if (match) {
                column.visible = match.visible;
                column.width = match.width;
                column.calculateAverage = match.calculateAverage;
                column.calculateSum = match.calculateSum;
            }
        });
        return columnSettings.sort(function (a, b) {
            var aIndex = fromSaved.findIndex(function (x) { return x.name === a.name; });
            var bIndex = fromSaved.findIndex(function (x) { return x.name === b.name; });
            return aIndex - bIndex;
        });
    };
    DataTableComponent.prototype.isDataItem = function (value) {
        return value !== null && typeof value === 'object';
    };
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Object)
    ], DataTableComponent.prototype, "columnSettingsDialogOpened", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], DataTableComponent.prototype, "delayForFetchingNewColumnData", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean),
        tslib_1.__metadata("design:paramtypes", [Boolean])
    ], DataTableComponent.prototype, "opened", null);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], DataTableComponent.prototype, "pageSize", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Object)
    ], DataTableComponent.prototype, "recordEditorEnabled", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], DataTableComponent.prototype, "maxDefaultColumns", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], DataTableComponent.prototype, "maxRecordsFetched", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], DataTableComponent.prototype, "defaultRecordsFetched", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], DataTableComponent.prototype, "enableAdditionalInformation", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], DataTableComponent.prototype, "scrollSize", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], DataTableComponent.prototype, "scrollSpeed", void 0);
    return DataTableComponent;
}(BaseComponent));
export { DataTableComponent };
